module.exports = __webpack_public_path__ + "static/media/plane-alt.5d1fa469.svg";